/* ============
 * Register personal informations Transformer
 * ============
 *
 * The transformer for the personal information.
 */

import Transformer from './../transformer';

export default class PersonalInfoTransformer extends Transformer {
  /**
   * Method used to transform a fetched personalInfo
   *
   * @param personalInfo The fetched personalInfo
   *
   * @returns {Object} The transformed personalInfo
   */
  static fetch(personalInfo) {
    return {
      phoneNumber: personalInfo.phone_number,
      streetName: personalInfo.street_name,
      secondStreetName: personalInfo.second_street_name,
      postalCode: personalInfo.postal_code,
      cityName: personalInfo.city_name,
    };
  }

  /**
   * Method used to transform a send personalInfo
   *
   * @param personalInfo The personalInfo to be send
   *
   * @returns {Object} The transformed personalInfo
   */
  static send(personalInfo) {
    return {
      phone_number: personalInfo.phoneNumber,
      street_name: personalInfo.streetName,
      second_street_name: personalInfo.secondStreetName,
      postal_code: personalInfo.postalCode,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/custom/registerPersonalInfo.js